import { useEffect, useState } from 'react';
import { useBreadcrumbsContext } from '../../../../app/context';
import { ApplicationDetailsContent } from './components/ApplicationDetailsContent';
import { ApplicationDetailsContainer } from './styles';
import { useParams } from 'react-router-dom';
import { useApplicationsService } from 'modules/products/services/hooks';
import { TApplicationResponse } from 'modules/products/services/hooks/interfaces';
import { BoxIcon } from 'app/components/Icons';
import { useTheme } from '@mui/material';
import { EmptyContent } from '../ProductDetail/components/EmptyContent';
import { BoxSection } from 'app/components';

const ApplicationDetails = () => {
  const theme = useTheme();
  const params = useParams();
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { getApplication } = useApplicationsService();

  const [isEmpty, setIsEmpty] = useState(false);
  const [applicationData, setApplicationData] =
    useState<TApplicationResponse | null>(null);

  const getApplicationHandler = async (id: string) => {
    const res = await getApplication(id);

    if (res) {
      return setApplicationData(res);
    }

    return setIsEmpty(true);
  };

  useEffect(() => {
    const applicationId = params.id;
    if (applicationId) {
      getApplicationHandler(applicationId);
    }
  }, [params]);

  useEffect(() => {
    setItems(
      [
        {
          to: `/products/detail/${applicationData?.product.id}/applications?page=0`,
          label: 'Produtos',
        },
        {
          to: `/products/application/${applicationData?.id}/details`,
          label: 'Detalhes',
        },
      ],
      <BoxIcon color={theme.palette.text.secondary} />,
    );

    return () => resetBreadcrumbs();
  }, [applicationData]);

  return (
    <ApplicationDetailsContainer>
      {applicationData && (
        <ApplicationDetailsContent
          applicationData={applicationData}
          updateApplicationData={setApplicationData}
        />
      )}
      {isEmpty && (
        <BoxSection>
          <EmptyContent titleText="Não foi possível encontrar este produto" />
        </BoxSection>
      )}
    </ApplicationDetailsContainer>
  );
};

export default ApplicationDetails;
